import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["allowTooltipClicks", "variant", "p", "fontSize", "children", "content", "delay"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useRef, forwardRef } from 'react';
import useOnClickOutside from 'hooks/useOnClickOutside';
import usePopoverState from 'hooks/usePopoverState';
import useMergedRefs from 'hooks/useMergedRefs';
import Popover from 'components/Popover';
function getContent(content, parameters) {
  if (typeof content === 'function') {
    return content(parameters);
  }
  return content;
}
var Tooltip = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$allowTooltipClic = _ref.allowTooltipClicks,
    allowTooltipClicks = _ref$allowTooltipClic === void 0 ? false : _ref$allowTooltipClic,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'inverted' : _ref$variant,
    _ref$p = _ref.p,
    p = _ref$p === void 0 ? 'xs' : _ref$p,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 's' : _ref$fontSize,
    children = _ref.children,
    content = _ref.content,
    delay = _ref.delay,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _usePopoverState = usePopoverState({
      openDelay: delay
    }),
    isOpen = _usePopoverState.isOpen,
    open = _usePopoverState.open,
    close = _usePopoverState.close,
    toggle = _usePopoverState.toggle;
  var popOverRef = useRef(null);
  var mergedRefs = useMergedRefs([ref, popOverRef]);
  useOnClickOutside(allowTooltipClicks ? popOverRef : null, close, isOpen);
  return /*#__PURE__*/React.createElement(Popover, _extends({
    variant: variant,
    p: p,
    fontSize: fontSize
  }, otherProps, {
    isOpen: isOpen,
    ref: mergedRefs,
    content: getContent(content, {
      close: close
    })
  }), function (popover) {
    return children(_objectSpread(_objectSpread({}, popover), {}, {
      isOpen: isOpen,
      open: open,
      close: close,
      toggle: toggle
    }));
  });
});
Tooltip.displayName = 'Tooltip';
export { default as Arrow } from 'components/Arrow';
export default Tooltip;